<template>
	<div>
		<div class="none-list" v-if="!hasData">
			<img src="@/static/chuangwen/none.png" style="width:60px;height: 60px;"></img>
			<div style="color:#999999;font-size:21px;margin-top: 15px;">暂无数据</div>
		</div>
		<div v-if="hasData">
			<!-- 基础信息 -->
			<div class="pagecontent-title">基础信息</div>
			<div class="table-content">
				<div class="tabletr">
					<p>企业名称：{{obj.ent_name}}</p>
				</div>
				<div class="tabletr">
					<p>统一社会信用代码：{{obj.social_code}}</p>
				</div>
				<div class="tabletr">
					<p>企业类型：{{obj.ent_type_name}}</p>
				</div>
				<div class="tabletr">
					<p>法定代表人：{{obj.legal_person}}</p>
				</div>
				<div class="tabletr">
					<p>注册资本：{{obj.regist_capital}}万元</p>
				</div>
				<div class="tabletr">
					<p>成立日期：{{obj.regist_date}}</p>
				</div>
				<div class="tabletr">
					<p>企业地址：{{obj.address}}</p>
				</div>
			</div>

			<!-- 凭证数据 -->
			<div style="margin-bottom:15px">
				<div v-if="attachmentList.length > 0" v-for="(item,index) in attachmentList" :key="index">
					<div class="pagecontent-title" v-if="item.imgArr.length > 0">{{item.name}}</div>
					<div class="grid-photo" v-if="item.imgArr.length > 0">
						<div class="grid-photo-item" v-for="(img,imgIndex) in item.imgArr" :key="imgIndex">
							<img @click="openImg(img)" mode="aspectFill" class="aimg" :src="img" />
						</div>
					</div>
					<div class="grid-photo-text" v-if="item.imgArr.length > 0">{{item.desc}}</div>
				</div>
			</div>

		</div>


	</div>
</template>

<script>
	import {
		ImagePreview
	} from 'vant';
	import {
		findOneEnt
	} from "@/api/index.js"
	export default {
		data() {
			return {
				code: '',
				obj: {},
				attachmentList: []
			}
		},
		computed: {
			hasData() {
				if (JSON.stringify(this.obj) == '{}') {
					return false
				} else {
					return true
				}
			},
		},
		mounted() {
			this.code = this.$route.query.code
			console.log(this.code)
			this.findOneEnt()
		},
		methods: {
			//根据id获取企业信息
			async findOneEnt() {
				let params = {
					social_code: this.code
				}
				let res = await findOneEnt(params)
				console.log('’res',res)
				if (res.code == 0) {
					this.obj = res.result.obj
					this.attachmentList = JSON.parse(this.obj.attachment || '[]')
				}
			},
			//图片放大
			openImg(src) {
				ImagePreview({
					images: [
						src
					],
					closeable: true,
				});
			},
		}
	}
</script>
<style>
	.pagecontent-title {
		font-size: 24px;
		width: 100%;
		height: 80px;
		display: flex;
		align-items: center;
		box-sizing: border-box;
		padding-left: 18px;
	}

	.tabletr {
		font-size: 16px;
		height: 50px;
		color: #4C4C4C;
		box-sizing: border-box;
		padding: 0 18px;
	}

	.grid-photo {
		overflow: hidden;
		clear: both;
		padding: 0 16px;
	}

	.grid-photo .grid-photo-item {
		width: 31%;
		margin: 1.11%;
		height: 100px;
		float: left;
		position: relative;
	}

	.aimg {
		width: 100%;
		height: 100%;
	}

	.none-list {
		padding-top: 25%;
		text-align: center;
		padding-bottom: 10%
	}

	.grid-photo-text {
		color: #FF9900;
		background-color: #FEF7DE;
		padding: 7px 10px;
		margin: 7px 18px 0 18px;
		border-radius: 5px;
	}
</style>
